import React from "react";
import PropTypes from "prop-types";
import { ATTACHMENT_TYPES, CHAT_SCREEN_MODE } from "Utils/MessageHelpers";
import { useMessageOptions } from "UIComponents/Message/providers/MessageProvider";

import { calculateAspectRatioFit } from "../Utils";
import MediaWrapper, { MEDIA_VISIBILITY } from "../MediaWrapper";

const MAP_MEDIA_DIMENSIONS_TO_VIEW_MODE = {
  [CHAT_SCREEN_MODE.WIDGET]: {
    maxWidth: 250,
    maxHeight: 250,
  },
  [CHAT_SCREEN_MODE.FULL_SCREEN]: {
    maxWidth: 400,
    maxHeight: 300,
  },
  [CHAT_SCREEN_MODE.SIDE_PANE]: {
    maxWidth: 400,
    maxHeight: 300,
  },
  [CHAT_SCREEN_MODE.VIEW_MODE_SCREEN]: {
    maxWidth: 400,
    maxHeight: 300,
  },
};

const DEFAULT_MEDIA_DIMENSIONS = {
  width: 300,
  height: 300,
};

const SingleVisualMediaContainer = props => {
  const { attachment, onMediaClick } = props;

  const { type, metadata } = attachment;
  const {
    screenMode = CHAT_SCREEN_MODE.VIEW_MODE_SCREEN,
  } = useMessageOptions();

  const isVideo = type === ATTACHMENT_TYPES.VIDEO;

  const srcWidth = metadata?.width || DEFAULT_MEDIA_DIMENSIONS.width;
  const srcHeight = metadata?.height || DEFAULT_MEDIA_DIMENSIONS.height;

  const { width, height } = calculateAspectRatioFit({
    srcWidth,
    srcHeight,
    maxWidth: MAP_MEDIA_DIMENSIONS_TO_VIEW_MODE[screenMode].maxWidth,
    maxHeight: MAP_MEDIA_DIMENSIONS_TO_VIEW_MODE[screenMode].maxHeight,
  });

  return (
    <MediaWrapper
      onMediaClick={onMediaClick}
      iconVisibility={isVideo ? MEDIA_VISIBILITY.PERSISTENT : undefined}
      attachment={attachment}
      width={width}
      height={height}
    />
  );
};

SingleVisualMediaContainer.propTypes = {
  onMediaClick: PropTypes.func.isRequired,
  attachment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    metadata: PropTypes.object.isRequired,
  }).isRequired,
};

export default SingleVisualMediaContainer;
